import React from "react";
import { NavLink, Link } from "react-router-dom";
import { AiOutlineWhatsApp } from "react-icons/ai";
import { useGetAllCategoryListQuery } from "../../../utils/api/category/category.api";
import { FiPhoneCall } from "react-icons/fi";
import VersionChecker from "../../../versionChecker/VersionChecker";
import { FaInstagram } from "react-icons/fa";

const FOOTER_PATTERN_FILE = "KAZAMANSA LOGO_Pattern Fond Foncé 1.png";
const FOOTER_LOGO_FILE = "KAZAMANSA LOGO_Monochrome Blanc 1.png";

/** Fichiers dans `public/` : encodage du nom pour éviter les soucis d’URL (espaces, accents). */
function publicAssetUrl(fileName: string): string {
  const base = (process.env.PUBLIC_URL || "").replace(/\/$/, "");
  return `${base}/${encodeURIComponent(fileName)}`;
}

/** Ne pas mettre ce motif dans url() de index.css (css-loader tente de le bundler). */
function footerPatternBackground(): string {
  return `url("${publicAssetUrl(FOOTER_PATTERN_FILE)}")`;
}

const FrontFooter = () => {
  const { data } = useGetAllCategoryListQuery();
  const year = new Date().getFullYear();

  return (
    <>
      <div
        className="footer-pattern-band"
        role="presentation"
        aria-hidden="true"
        style={{ backgroundImage: footerPatternBackground() }}
      />
      <footer className="footer-component footer-component--kazamansa">
        <div className="container footer-kazamansa-inner pt-4 pb-3">
          <div className="footer-kazamansa-grid">
            <div className="footer-kazamansa-grid-logo">
              <div className="footer-kazamansa-logo-wrap">
                <img
                  loading="lazy"
                  src={publicAssetUrl(FOOTER_LOGO_FILE)}
                  alt="Kazamansa"
                  className="footer-kazamansa-logo"
                />
              </div>
            </div>

            <h3 className="footer-kazamansa-heading footer-kazamansa-grid-h1">
              Nous contacter
            </h3>

            <div className="footer-kazamansa-grid-body footer-kazamansa-grid-b1">
              <div className="footer-kazamansa-contact-block">
                <div className="footer-contact-us-item mb-3">
                  <span className="footer-kazamansa-icon" aria-hidden>
                    <AiOutlineWhatsApp size={20} />
                  </span>
                  <div>
                    <p className="footer-kazamansa-contact-label mb-0">WhatsApp</p>
                    <a
                      href="https://wa.me/message/SXCGITWN4Y4IB1"
                      className="footer-kazamansa-contact-link"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      +221 77 716 56 56
                    </a>
                  </div>
                </div>
                <div className="footer-contact-us-item">
                  <span className="footer-kazamansa-icon" aria-hidden>
                    <FiPhoneCall size={20} />
                  </span>
                  <div>
                    <p className="footer-kazamansa-contact-label mb-0">Téléphone</p>
                    <a href="tel:+221777165656" className="footer-kazamansa-contact-link">
                      +221 77 716 56 56
                    </a>
                  </div>
                </div>
              </div>
              <div className="footer-kazamansa-locations">
                <p className="footer-kazamansa-location-line mb-1">Dakar, Sénégal</p>
                <p className="footer-kazamansa-location-line mb-0">
                  Abidjan, Côte d&apos;Ivoire
                </p>
              </div>
            </div>

            <h3 className="footer-kazamansa-heading footer-kazamansa-grid-h2">
              Notre carrelage
            </h3>

            <ul className="list-unstyled footer-kazamansa-bullets mb-0 footer-kazamansa-grid-b2">
              {data?.results?.map((item) => (
                <li key={item.id}>
                  <Link
                    to={`/produits?categorie=${item.slug}`}
                    state={{ catgoryId: item.id }}
                    className="footer-kazamansa-list-link"
                  >
                    {item.nom}
                  </Link>
                </li>
              ))}
            </ul>

            <h3 className="footer-kazamansa-heading footer-kazamansa-grid-h3">
              Liens utiles
            </h3>

            <div className="footer-kazamansa-grid-b3">
              <ul className="list-unstyled footer-kazamansa-bullets mb-0">
                <li>
                  <NavLink to="/a-propos-de-nous" className="footer-kazamansa-list-link">
                    Qui sommes-nous ?
                  </NavLink>
                </li>
                <li>
                  <NavLink
                    to="/conditions-generales-de-ventes"
                    className="footer-kazamansa-list-link"
                  >
                    Conditions générales de vente
                  </NavLink>
                </li>
                <li>
                  <NavLink
                    to="/politique-de-confidentialite"
                    className="footer-kazamansa-list-link"
                  >
                    Politique de confidentialité
                  </NavLink>
                </li>
              </ul>
              <div className="footer-kazamansa-social">
                <a
                  className="footer-kazamansa-instagram"
                  href="https://www.instagram.com/kazamansa"
                  target="_blank"
                  rel="noopener noreferrer"
                  title="Instagram"
                  aria-label="Instagram Kazamansa"
                >
                  <FaInstagram size={22} />
                </a>
              </div>
            </div>
          </div>

          <div className="footer-kazamansa-copyright-wrap">
            <div className="footer-kazamansa-separator" />
            <p className="footer-kazamansa-copyright text-center mb-0">
              © {year}, <strong>KAZAMANSA</strong>,{" "}
              <a
                href="https://easymarket.sn"
                target="_blank"
                rel="noopener noreferrer"
                className="footer-kazamansa-powered"
              >
                Commerce électronique propulsé par Easymarket.sn
              </a>
            </p>
          </div>
          <div className="version-view-container text-end text-white fw-bold footer-kazamansa-version">
            {"v" + VersionChecker()}
          </div>
        </div>
      </footer>
    </>
  );
};

export default FrontFooter;
